/* eslint-disable no-unused-vars */
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay,
  Thumbs,
} from "swiper/modules";

export default function initSliders() {
  // Our work slider
  const ourWorkSlider = new Swiper(".our-work-slider__slides-wrapper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1.1,
    spaceBetween: 16,
    loop: true,
    wrapperClass: "our-work-slider__slides",
    slideClass: "our-work-slider__slide",
    navigation: {
      nextEl: ".our-work-slider__controls__button--next",
      prevEl: ".our-work-slider__controls__button--prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.1, spaceBetween: 16 },
      320: { slidesPerView: 1.1, spaceBetween: 24 },
    },
  });

  // Pause autoplay on hover
  const sliderEl = document.querySelector(".our-work-slider__slides-wrapper");
  if (sliderEl) {
    sliderEl.addEventListener("mouseenter", () => {
      ourWorkSlider.autoplay.stop();
    });
    sliderEl.addEventListener("mouseleave", () => {
      ourWorkSlider.autoplay.start();
    });
  }

  // Testimonial slider
  const testimonialSlider = new Swiper(".testimonial-slider__slides-wrapper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 2.1,
    spaceBetween: 16,
    loop: true,
    wrapperClass: "testimonial-slider__slides",
    slideClass: "testimonial-slider__slide",
    navigation: {
      nextEl: ".testimonial-slider__controls__button--next",
      prevEl: ".testimonial-slider__controls__button--prev",
    },
    pagination: {
      el: ".testimonial-slider__pagination",
      clickable: true,
      bulletClass: "testimonial-slider__bullet",
      bulletActiveClass: "testimonial-slider__bullet--active",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: { slidesPerView: 1.1, spaceBetween: 16 },
      320: { slidesPerView: 1.1, spaceBetween: 16 },
      600: { slidesPerView: 1.1, spaceBetween: 16 },
      800: { slidesPerView: 2.1, spaceBetween: 16 },
      1200: { slidesPerView: 2.1, spaceBetween: 72 },
    },
  });

  // Pause autoplay on hover
  const testimonialSliderEl = document.querySelector(
    ".testimonial-slider__slides-wrapper",
  );
  if (testimonialSliderEl) {
    testimonialSliderEl.addEventListener("mouseenter", () => {
      testimonialSlider.autoplay.stop();
    });
    testimonialSliderEl.addEventListener("mouseleave", () => {
      testimonialSlider.autoplay.start();
    });
  }
}
